import { render, staticRenderFns } from "./IndexColumn.vue?vue&type=template&id=897da056&"
import script from "./IndexColumn.vue?vue&type=script&lang=ts&"
export * from "./IndexColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports